import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import LanguageSwitcher from '@layouts/langSwitch/componenets/LanguageSwitcher';
import { authService } from '../../../../providers/context/services/authService';
import { notifySuccess, notifyError } from '@config/tostifyConfig/tostifyConfig';

const ChangePassword = () => {
    const { t } = useTranslation();

    const validationSchema = yup.object({
        currentPassword: yup.string()
            .required(t('changePassword.requiredPassword'))
            .min(1, t('changePassword.minLength'))
            .max(60, t('changePassword.maxLength')),
        newPassword: yup.string()
            .required(t('changePassword.requiredPassword'))
            .min(1, t('changePassword.minLength'))
            .max(60, t('changePassword.maxLength')),
        confirmPassword: yup.string()
            .required(t('changePassword.requiredPassword'))
            .oneOf([yup.ref('newPassword')], t('changePassword.passwordsDoNotMatch'))
    });

    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onChange'
    });

    const onSubmit = async (data) => {
        try {
            const passwordData = {
                oldPassword: data.currentPassword,
                newPassword: data.newPassword,
                confirmNewPassword: data.confirmPassword
            };

            await authService.changePassword(passwordData);
            reset();
            const serverMessaage = response.data || t('changePassword.successMessage');
            notifySuccess(serverMessaage);
        } catch (error) {
            console.error('Password change error:', error);
            
            const serverMessage = error.response?.data || t('changePassword.errorMessage');
            notifyError(serverMessage);
        }
    };

    return (
        <div className='login-wrapper'>
            <div className="login-form-container">
                <LanguageSwitcher />
                <h3>{t('changePassword.title')}</h3>
                <hr/>
                <img 
                    src="/images/logo/bulmagMiddle.png" 
                    alt="Logo" 
                    className="login-company-logo"
                    height="30"
                />
                <form className='form' onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                        <label htmlFor="currentPassword">{t('changePassword.currentPassword')}</label>
                        <input
                            type="password"
                            {...register('currentPassword')}
                            id="currentPassword"
                            className={`form-control ${errors.currentPassword ? 'is-invalid' : ''}`}
                        />
                        {errors.currentPassword && 
                            <div className='invalid-feedback'>{errors.currentPassword.message}</div>
                        }
                    </div>
                    <div className="form-group">
                        <label htmlFor="newPassword">{t('changePassword.newPassword')}</label>
                        <input
                            type="password"
                            {...register('newPassword')}
                            id="newPassword"
                            className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                        />
                        {errors.newPassword && 
                            <div className='invalid-feedback'>{errors.newPassword.message}</div>
                        }
                    </div>
                    <div className="form-group">
                        <label htmlFor="confirmPassword">{t('changePassword.confirmPassword')}</label>
                        <input
                            type="password"
                            {...register('confirmPassword')}
                            id="confirmPassword"
                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                        />
                        {errors.confirmPassword && 
                            <div className='invalid-feedback'>{errors.confirmPassword.message}</div>
                        }
                    </div>
                    <button className='login-btn' type="submit">
                        {t('changePassword.submit')}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ChangePassword; 